import { render } from "./ViewActionHistory.vue?vue&type=template&id=5d277e3e"
import script from "./ViewActionHistory.vue?vue&type=script&lang=js"
export * from "./ViewActionHistory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__